import type { MailboxTab, SocialTab, UserMenuTab } from './types';

export function createTopTabButton(tab: UserMenuTab, label: string, onClick: (tab: UserMenuTab) => void): HTMLButtonElement {
    return createTabButton(tab, label, onClick, { fontSize: '1.05rem', padding: '6px 10px' });
}

export function createSocialTabButton(tab: SocialTab, label: string, onClick: (tab: SocialTab) => void): HTMLButtonElement {
    return createTabButton(tab, label, onClick, { fontSize: '1.1rem', padding: '4px 8px' });
}

export function createMailboxTabButton(tab: MailboxTab, label: string, onClick: (tab: MailboxTab) => void): HTMLButtonElement {
    return createTabButton(tab, label, onClick, { fontSize: '1.1rem', padding: '4px 8px' });
}

function createTabButton<T extends string>(
    tab: T,
    label: string,
    onClick: (tab: T) => void,
    styleOverrides: Partial<CSSStyleDeclaration>
): HTMLButtonElement {
    const btn = document.createElement('button');
    btn.textContent = label;
    btn.type = 'button';
    Object.assign(btn.style, {
        backgroundColor: 'transparent',
        border: 'none',
        color: '#9ca3af',
        fontSize: '1.1rem',
        cursor: 'pointer',
        padding: '4px 8px',
        borderRadius: '4px',
        transition: 'color 0.2s, backgroundColor 0.2s',
        ...styleOverrides,
    });
    btn.addEventListener('click', () => onClick(tab));
    return btn;
}

export function createActionButton(label: string, color: string): HTMLButtonElement {
    const btn = document.createElement('button');
    btn.textContent = label;
    btn.type = 'button';
    Object.assign(btn.style, {
        padding: '8px 16px',
        backgroundColor: color,
        color: '#fff',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: '0.9rem',
    });
    return btn;
}

export function createMailboxRow(params: { senderLabel: string; timeLabel: string; thirdOption: string }): HTMLDivElement {
    const item = document.createElement('div');
    Object.assign(item.style, {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '10px',
        padding: '8px',
        backgroundColor: 'rgba(255,255,255,0.05)',
        borderRadius: '4px',
    });

    const left = document.createElement('div');
    Object.assign(left.style, {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
        minWidth: '0',
        flex: '1',
    });

    const sender = document.createElement('div');
    sender.textContent = params.senderLabel;
    sender.style.color = '#e5e7eb';

    const time = document.createElement('div');
    time.textContent = params.timeLabel;
    time.style.color = '#9ca3af';
    time.style.fontSize = '0.78rem';

    const thirdOption = document.createElement('div');
    thirdOption.textContent = params.thirdOption;
    thirdOption.style.color = '#cbd5e1';
    thirdOption.style.fontSize = '0.82rem';
    thirdOption.style.whiteSpace = 'nowrap';
    thirdOption.style.overflow = 'hidden';
    thirdOption.style.textOverflow = 'ellipsis';
    thirdOption.style.maxWidth = '240px';

    left.appendChild(sender);
    left.appendChild(time);
    left.appendChild(thirdOption);
    item.appendChild(left);
    return item;
}
